import React from "react"

import { gql, useQuery } from "hooks/urql"

import BasicDisplay from "components/BasicDisplay"
import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

import RemoveAcrClass from "../Remove"

import ClassPeriodsList from "./ClassPeriods/ClassPeriodsList"
import GenerateClassPeriods from "./ClassPeriods/GenerateClassPeriods"
import AddStudents from "./Students/AddStudents"
import StudentsList from "./Students/StudentsList"

type AcrClassDetailsProps = {
  id: string
}

const AcrClassDetails: React.FC<AcrClassDetailsProps> = ({ id }) => {
  const [result] = useQuery({
    query: acrClassQuery,
    variables: { id },
  })

  return (
    <UrqlLoadingIndicator result={result}>
      {({ data: { acrClass } }) => (
        <>
          <a
            href={acrClass.editPath}
            className="btn btn-md btn-warning !font-semibold"
          >
            Edit
          </a>
          <RemoveAcrClass id={acrClass.id} />
          <BasicDisplay label="Teacher">
            <a href={acrClass.teacher.showPath}>{acrClass.teacher.fullName}</a>
          </BasicDisplay>
          <BasicDisplay label="School">
            <a href={acrClass.school.showPath}>{acrClass.school.name}</a>
          </BasicDisplay>
          <BasicDisplay label="Name" value={acrClass.name} />
          <BasicDisplay label="Subject" value={acrClass.subject.name} />
          <BasicDisplay label="Grade" value={acrClass.grade.name} />
          <BasicDisplay
            label="Timezone"
            value={acrClass.teacher.emailTimeZone}
          />

          <div className="mt-4">
            <h4 className="m-0">Students</h4>
            <AddStudents
              acrClassId={acrClass.id}
              schoolId={acrClass.school.id}
            />
            <StudentsList
              acrClassId={acrClass.id}
              students={acrClass.students}
            />
          </div>

          <div className="mt-4">
            <h4 className="m-0">Class Periods</h4>
            <GenerateClassPeriods
              acrClassId={acrClass.id}
              timeZone={acrClass.teacher.emailTimeZone}
            />
            <ClassPeriodsList
              periods={acrClass.acrClassPeriods}
              timeZone={acrClass.teacher.emailTimeZone}
              ianaTimeZone={acrClass.teacher.ianaEmailTimeZone}
            />
          </div>
        </>
      )}
    </UrqlLoadingIndicator>
  )
}

const acrClassQuery = gql`
  query AdminAcrClassDetails($id: ID!) {
    acrClass(id: $id) {
      id
      name
      editPath
      school {
        id
        name
        showPath
      }
      subject {
        id
        name
      }
      grade {
        id
        name
      }
      teacher {
        id
        fullName
        showPath
        emailTimeZone
        ianaEmailTimeZone
      }
      acrClassPeriods {
        id
        startsAt
        endsAt
      }
      students {
        id
        fullName
        showPath
      }
    }
  }
`

export default AcrClassDetails
